import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PermissionService } from '../../services/permission.service';

@Component({
  template: '',
})
export abstract class BaseComponent {
  public permissionService = inject(PermissionService);
  protected location: Location = inject(Location);

  protected cancel(): void {
    this.location.back();
  }
}
